import { createSelector } from 'reselect';


const getSuggestionsFromState = state => state.search.suggestions;

const getSuggestions = createSelector(
  [getSuggestionsFromState],
  (suggestions) => {
    if (suggestions && suggestions.available) {
      const filteredSuggestions = [];
      const order = {
        brand: 0,
        category: 1,
        content: 3,
        recent: 4,
        popular: 5,
        product: 6,
      };

      Object.keys(suggestions)
        .sort((first, second) => order[first] - order[second])
        .forEach((key) => {
          const suggestion = suggestions[key];

          if (suggestion.available) {
            const test = suggestion.suggestions || suggestion.phrases;

            filteredSuggestions.push(...test);
          }
        });
      return filteredSuggestions;
    }
    return [];
  },
);

export default getSuggestions;
